<template>
  <tr ref="row" @click="toggle()" :class="!isLast ? 'border-b border-bdefault' : ''">
    <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor">
      {{ $formatDate(data.ContactDate) }}
    </td>
    <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor">Contact</td>
    <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor">{{ data.UserName }}</td>

    <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor">
      <span>
        {{ isExpanded(data) ? data.Comments : truncateText(data.Comments) }}
      </span>
    </td>
    <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor"></td>
    <td class="py-3.5 pl-4 pr-3 text-left text-base text-pdsPrimaryColor break-words">
      <button
        v-if="data.Comments && data.Comments.length > 50"
        @click="toggle(data)"
        class="flex justify-center py-2 px-2 md:px-4 border border-primary-default shadow-sm text-sm font-medium text-primary-default bg-white rounded-full hover:bg-primary-default/50 items-center"
      >
        <template v-if="isExpanded(data)"> Toon minder </template>
        <template v-else>Toon meer </template>
      </button>
    </td>
  </tr>
</template>
<script>
import { currentUserIdentity$ } from '@/services';
import { useStore } from 'vuex';
import { ref } from 'vue';
import { number } from 'yup';

export default {
  name: 'ContactDetailsRow',
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    licenseId: {
      type: Number,
      default: 0
    },
    isLast: {
      type: Boolean
    }
  },
  setup(props) {
    const store = useStore();
    const user = ref(null);
    const expandedRows = ref(new Set());

    currentUserIdentity$.subscribe((value) => {
      user.value = value;
    });
    const toggle = (row) => {
      if (expandedRows.value.has(row)) {
        expandedRows.value.delete(row);
      } else {
        expandedRows.value.add(row);
      }
    };
    const isExpanded = (row) => {
      return expandedRows.value.has(row);
    };

    const truncateText = (text) => {
      if (!text) return '';
      return text.length > 100 ? text.slice(0, 50) + '...' : text;
    };

    return {
      store,
      user,
      isExpanded,
      toggle,
      truncateText
    };
  }
};
</script>
